module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-ties-remnants.30f68a7a.png";